<template>
<div class="section">
    <div class="container">
        <h1 class="title is-1">Page</h1>
    </div>
</div>
</template>

<script>
export default {
    name    :   'Page',
    props   :   ['site_data', 'is_mobile']
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Page.vue